import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import FeaturesSection from "@/components/FeaturesSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import TeamSection from "@/components/TeamSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PricingSection from "@/components/PricingSection";
import DemoCtaSection from "@/components/DemoCtaSection";
import ContactSection from "@/components/ContactSection";
import ApplySection from "@/components/ApplySection";
import FAQSection from "@/components/FAQSection";
import BlogSection from "@/components/BlogSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Index = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <HeroSection />
    <AboutSection />
    <FeaturesSection />
    <HowItWorksSection />
    <TeamSection />
    <TestimonialsSection />
    <PricingSection />
    <FAQSection />
    <BlogSection />
    <DemoCtaSection />
    <ContactSection />
    <ApplySection />
    <Footer />
    <WhatsAppButton />
  </div>
);

export default Index;
